import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import AdBlockerPlusDetector from '@xingternal/ad-blocker-plus-detector';
import { GridContainer } from '@xingternal/xing-grid';
import testable from '@xingternal/malt-util/testable';
import { NSP_CORE } from '@xingternal/malt-constants';
import { HeaderLoggedOut } from '@xingternal/platform-layout-header-logged-out';
import { Footer } from '@xingternal/platform-layout-footer';
import { CenterContainer } from '@xingternal/platform-layout-view-wrapper';

import styles from './LoggedoutView.css';

const TestableDiv = testable(NSP_CORE, 'div');

const LoggedoutView = ({
  children,
  className,
  contentClassName,
  gridClassName,
  hideLoginButton,
  hideSignupButton,
  homeLink,
  loginLink,
  signupLink,
  testId,
  type,
}) => {
  return (
    <TestableDiv className={cx(styles.wrapper, className)} testId={testId}>
      <AdBlockerPlusDetector />
      <HeaderLoggedOut
        {...{
          hideLoginButton,
          hideSignupButton,
          homeLink,
          loginLink,
          signupLink,
        }}
      />

      <CenterContainer
        className={cx(styles.shell, {
          [styles.fullScreenShell]: type === 'fullScreen',
        })}
      >
        <section className={cx(styles.scrollWrapper, styles.wideWrapper)}>
          <div className={cx(styles.container, contentClassName)}>
            <main id="content" className={styles.main}>
              <GridContainer className={gridClassName} type={type}>
                {children}
              </GridContainer>
            </main>
          </div>
        </section>
      </CenterContainer>

      <Footer homeLink={homeLink} />
    </TestableDiv>
  );
};

LoggedoutView.defaultProps = {
  type: 'standard',
  homeLink: '/',
};

LoggedoutView.propTypes = {
  // Props
  className: PropTypes.string,
  children: PropTypes.node,
  contentClassName: PropTypes.string,
  gridClassName: PropTypes.string,
  hideLoginButton: PropTypes.bool,
  hideSignupButton: PropTypes.bool,
  homeLink: PropTypes.string,
  loginLink: PropTypes.string,
  signupLink: PropTypes.string,
  testId: PropTypes.string,
  type: PropTypes.oneOf(['standard', 'wide']),
};

export { LoggedoutView };
